import constantURL from "./ConstantURL";
import { isPasswordValid, PASSWORD_CRITERIA_INVALID_MESSAGE } from "../utils/passwordCriteria";

export const PASSWORD_ALREADY_SET_CODE = "PASSWORD_ALREADY_SET";
export const TOKEN_INVALID_OR_EXPIRED_CODE = "TOKEN_INVALID_OR_EXPIRED";

export const PASSWORD_ALREADY_SET_MESSAGE =
  "Password setup has been completed. Please login to the mobile app.";
export const TOKEN_INVALID_OR_EXPIRED_MESSAGE =
  "Password setup link is invalid or expired. Please contact administrator.";

const resolveTokenError = (data) => {
  const code = data?.data?.code;

  if (code === PASSWORD_ALREADY_SET_CODE) {
    return {
      success: false,
      errorCode: PASSWORD_ALREADY_SET_CODE,
      message: data?.message || PASSWORD_ALREADY_SET_MESSAGE,
    };
  }

  if (code === TOKEN_INVALID_OR_EXPIRED_CODE) {
    return {
      success: false,
      errorCode: TOKEN_INVALID_OR_EXPIRED_CODE,
      message: TOKEN_INVALID_OR_EXPIRED_MESSAGE,
    };
  }

  if (data?.status === "error") {
    return {
      success: false,
      errorCode: TOKEN_INVALID_OR_EXPIRED_CODE,
      message: data?.message || TOKEN_INVALID_OR_EXPIRED_MESSAGE,
    };
  }

  return {
    success: false,
    errorCode: TOKEN_INVALID_OR_EXPIRED_CODE,
    message: TOKEN_INVALID_OR_EXPIRED_MESSAGE,
  };
};

const fetchWithSetupToken = async (url, { method = "GET", body } = {}, setupToken) => {
  const token = String(setupToken || "").trim();
  const options = {
    method,
    mode: "cors",
    credentials: "include",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  if (body !== undefined) {
    options.headers["Content-Type"] = "application/json";
    options.body = JSON.stringify(body);
  }

  const response = await fetch(url, options);
  let data = null;

  try {
    data = await response.json();
  } catch {
    data = null;
  }

  return { ok: response.ok, status: response.status, data };
};

export const validateSetupToken = async (setupToken) => {
  const token = String(setupToken || "").trim();
  if (!token) {
    return {
      success: false,
      errorCode: TOKEN_INVALID_OR_EXPIRED_CODE,
      message: TOKEN_INVALID_OR_EXPIRED_MESSAGE,
    };
  }

  try {
    const { ok, data } = await fetchWithSetupToken(constantURL.familymemberValidateSetupToken, { method: "GET" }, token);

    if (ok && data?.status === "success") {
      return { success: true, message: data.message || "" };
    }

    return resolveTokenError(data);
  } catch {
    return {
      success: false,
      errorCode: TOKEN_INVALID_OR_EXPIRED_CODE,
      message: TOKEN_INVALID_OR_EXPIRED_MESSAGE,
    };
  }
};

export const setPasswordWithToken = async ({ setupToken, newPassword, confirmPassword }) => {
  const token = String(setupToken || "").trim();

  if (!token) {
    return {
      success: false,
      errorCode: TOKEN_INVALID_OR_EXPIRED_CODE,
      message: TOKEN_INVALID_OR_EXPIRED_MESSAGE,
    };
  }

  if (!isPasswordValid(newPassword)) {
    return { success: false, tokenInvalid: false, message: PASSWORD_CRITERIA_INVALID_MESSAGE };
  }

  if (newPassword !== confirmPassword) {
    return { success: false, tokenInvalid: false, message: "Passwords do not match." };
  }

  try {
    const { ok, data } = await fetchWithSetupToken(
      constantURL.familymemberSetPassword,
      {
        method: "POST",
        body: {
          newPassword,
          confirmPassword,
        },
      },
      token,
    );

    if (ok && data?.status === "success") {
      return { success: true, message: data.message || "Your password has been set. You can sign in now." };
    }

    const tokenError = resolveTokenError(data);
    return {
      success: false,
      errorCode: tokenError.errorCode,
      message: tokenError.message,
      tokenInvalid: true,
    };
  } catch {
    return {
      success: false,
      errorCode: TOKEN_INVALID_OR_EXPIRED_CODE,
      message: TOKEN_INVALID_OR_EXPIRED_MESSAGE,
      tokenInvalid: true,
    };
  }
};
